import React from 'react';
import { inject, observer } from 'mobx-react';
import { TopBar } from '../../components/TopBar';
import { MainTopBarMenu } from '../../components/MainTopBarMenu';
import { ReportsLinks } from '../../components/ReportsLinks';
import { ReportPaginator } from '../../components/ReportPaginator';
import { RightPanel } from '../../components/RightPanel';
import { ParentFilterPanel } from '../../components/filters/ParentFilterPanel';
import { Modal, Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast , Bounce} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {IMaskInput} from 'react-imask';
import { VirtualTerminal } from '../../components/VirtualTerminal';
import { toJS } from "mobx";
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { BiMailSend, BiShare, BiX, BiXCircle, BiNotepad, BiDollarCircle, BiDotsVerticalRounded, BiCheckCircle, BiSortAlt2 } from 'react-icons/bi';
import {HiCheckCircle, HiXCircle } from 'react-icons/hi';
import {Link} from "react-router-dom";
import { PayabliStorageManager } from '../../api/localStorageManager';
import { Layout } from '../../components/Layout'
import { CustomerLinks } from '../../components/CustomerLinks';
import { RecordsNotFound } from '../../components/RecordsNotFound';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { MainBar } from '../../components/MainBar';
import { MdOutlineCallSplit } from 'react-icons/md'
import { QuickViewTransaction } from '../../components/QuickViewTransaction';
import { AiOutlineAlert } from 'react-icons/ai';

@inject('reports', 'global', 'vTerminal', 'customer', 'management', 'filter')
@observer
class TransactionsReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            head: "",
            sortDirection: "desc",
            voidModalIsOpen: true,
            reversalCreditModalIsOpen: false,
            transIdToVoid: null,
            refundModalIsOpen: true,
            transIdToRefund: null,
            refundAmount: "0.00",
            refundAmountError: false,
            refundAmountMax: 0,
            captureModalIsOpen: false,
            transIdToCapture: null,
            captureAmount: "0.00",
            captureAmountError: false,
            captureAmountMax: 0,
            transIdToSendReceipt: null,
            sendReceiptModalIsOpen: true,
            sendReceiptAddress: "",
            sendReceiptError: true,
            captureReceiptModalIsOpen: false,
            vterminalRightPanelOpen: false,
            vTerminalAutopay: 1,
            customerId: null,
            customFields: [],
            userPermissions:[],
            currentCustomer: null,
            paymentTransId: null,
            flagItemAllColumn: true,
            actionCapture: false
        };
        this.handleShowColumn = this.handleShowColumn.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.viewRecordDetails = this.viewRecordDetails.bind(this);
        this.filter = this.filter.bind(this);
        this.showHideFilters = this.showHideFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.getReportFromApi = this.getReportFromApi.bind(this);        
        this.getIconResponse = this.getIconResponse.bind(this);
        this.voidTransaction = this.voidTransaction.bind(this);
        this.openVoidModal = this.openVoidModal.bind(this);
        this.voidTransactionAction = this.voidTransactionAction.bind(this);
        this.closeVoidModal = this.closeVoidModal.bind(this);        
        this.closeRefundModal = this.closeRefundModal.bind(this);
        this.refundTransactionAction = this.refundTransactionAction.bind(this);
        this.handleRefundAmount = this.handleRefundAmount.bind(this);
        this.refundTransaction = this.refundTransaction.bind(this);
        this.closeCaptureModal = this.closeCaptureModal.bind(this);
        this.captureTransactionAction = this.captureTransactionAction.bind(this);
        this.handleCaptureAmount = this.handleCaptureAmount.bind(this);
        this.captureTransaction = this.captureTransaction.bind(this);
        this.closeCaptureReceiptModal = this.closeCaptureReceiptModal.bind(this);
        this.openSendReceiptModal = this.openSendReceiptModal.bind(this);
        this.sendTransactionReceipt = this.sendTransactionReceipt.bind(this);
        this.closeSendReceiptModal = this.closeSendReceiptModal.bind(this);
        this.sendReceiptTransactionAction = this.sendReceiptTransactionAction.bind(this);
        this.closeVterminalPanel = this.closeVterminalPanel.bind(this);
        this.openVterminalPanel = this.openVterminalPanel.bind(this);
        this.chargeAgain = this.chargeAgain.bind(this);
        this.getCustomFieldsFromApi = this.getCustomFieldsFromApi.bind(this);
        this.focus = this.focus.bind(this);
        this.selectAllColumns = this.selectAllColumns.bind(this);
        this.getNameComponent = this.getNameComponent.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.reversalCreditTransaction = this.reversalCreditTransaction.bind(this);
        this.renderModalRisks = this.renderModalRisks.bind(this);
        this.showModalConfirmationRisks = this.showModalConfirmationRisks.bind(this);
        this.savedActionsRisks = this.savedActionsRisks.bind(this);
        this.renderActionHoldReleasedTrx = this.renderActionHoldReleasedTrx.bind(this);
        this.quickViewTransaction = React.createRef();
    }
    getNameComponent(){
        return (
            <>
                { (this.props.match.params.id && this.state.currentCustomer) &&
                    <h5>Customer - {this.props.global.capitalizeFirstLetterOfEachWord(this.state.currentCustomer.Firstname)} {this.props.global.capitalizeFirstLetterOfEachWord(this.state.currentCustomer.Lastname)}</h5>
                }
                <div className="mr-1 inline">
                    {
                        this.state.paymentTransId ? <h6>Trans. Id: {this.state.paymentTransId}</h6> : <h6 data-qaid="allTransactionsMoneyInReportsPage">{this.state.head ? this.props.global.capitalizeFirstLetter(this.state.head) : "All Transactions"}</h6>
                    }
                </div>
            </>
        )
    }
    focus(e){
        e.target.focus();
        e.target.setSelectionRange(0, 1000000000);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.location.pathname !==prevProps.location.pathname){
            window.location.href = "/" + this.props.global.getURLEntry() +"/report/transactions"
        }
    }
    
    componentDidMount() {
        let encryptStorage = PayabliStorageManager.getEncryptedLocalStorage();
        let userPermissions = encryptStorage && encryptStorage.getItem('pUser') && encryptStorage.getItem('pUser').permissions ? encryptStorage.getItem('pUser').permissions : [];;
        this.setState({ 
            customerId: this.props.match.params.id ? this.props.match.params.id : null, 
            userPermissions: userPermissions,
            paymentTransId: this.props.match.params.paymentTransId ? this.props.match.params.paymentTransId : null,
            idtransRefund: this.props.match.params.idtransRefund ? this.props.match.params.idtransRefund : null
        });

        if(this.props.match.params.id){
            this.props.customer.getCustomerFromApi(this.props.match.params.id).then(res => {
                this.setState({currentCustomer:res.data});
            })
            .catch(error => {
                toast.error("Something is Wrong", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            });
        }else{
            this.setState({currentCustomer:null});
        }

        this.props.global.protect(this.props.history);
        this.props.reports.setFrom(0);
        this.props.global.setRightPanelOpen(false);
        this.props.global.setLoading(true);
        this.props.reports.setHeaders(
            {
                paymentId           : { label:'Payment ID', class: '', display: false },
                gatewayTransId      : { label:'Transaction ID', class: '', display: false }, 
                orderId             : { label:'Order ID', class: '', display: false }, 
                batchNumber         : { label:'Batch #', class: '', display: false },
                ExternalPaypointID    : { label:'External Paypoint ID', class: '', display: false },  
                customer            : { label:'Customer', class: '', display: true }, 
                company             : { label:'Company', class: '', display: true },
                customerNumber      : { label:'Customer #', class: '', display: false },
                billingEmail        : { label:'Email', class: '', display: false },  
                payorPhone          : { label:'Phone #', class: '', display: false },
                billingAddress      : { label:'Billing Address', class: '', display: false },
                shippingAddress     : { label:'Shipping Address', class: '', display: false },
                invoiceNumber       : { label:'Invoice #', class: '', display: true}, 
                date                : { label:'Date', class: '', display: true, filter: 'date'}, 
                time                : { label:'Time (' + this.props.global.getTimeZone('v1') + ')' , class: '', display: true}, 
                brand               : { label:'Pay Method', class: 'text-center', display: true }, 
                last4               : { label:'Last 4', class: '', display: true }, 
                type                : { label:'Type', class: '', display: true },
                cycle               : { label:'Cycle', class: '', display: false},
                status              : { label:'Payment Status', class: '', display: true },
                settlementStatus    : { label:'Batch Status', class: '', display: true }, 
                netAmount           : { label:'Amount', class: 'text-right', display: true }, 
                feeAmount           : { label:'Fee', class: 'text-right', display: false }, 
                totalAmount         : { label:'Total Amount', class: 'text-right', display: false },
                currency            : { label:'Currency', class: 'text-center', display: false }, 
                authCode            : { label:'Auth. Code', class: '', display: false}, 
                source              : { label:'Source', class: '', display: false },
                notes               : { label:'Notes', class: 'text-center', display: true }
            }
        )
        this.getCustomFieldsFromApi();
        this.props.reports.setRecords([]);
        this.clearFilters();

	    if(this.props.match.params.gobackData){
            let urlData = decodeURIComponent(this.props.match.params.gobackData);
            try {
                let gobackData = JSON.parse(window.atob(urlData));
                this.setState({gobackData: gobackData});
              } catch (ex) {}
        }
    }

    selectAllColumns(e, containerId){
        let menuContainer = document.querySelector('[aria-labelledby="'+containerId+'"]');
        let checkBoxes = menuContainer.getElementsByTagName('input');
        for(var i = 0; i < checkBoxes.length; i++) {
            if(checkBoxes[i].type.toLowerCase() === 'checkbox' && checkBoxes[i].checked === !e.target.checked) {
                checkBoxes[i].click();
            }
        }
        this.setState({flagItemAllColumn: false});
    }

    getCustomFieldsFromApi(){
        let encryptStorage = PayabliStorageManager.getEncryptedLocalStorage();
        let entry = encryptStorage && encryptStorage.getItem(`${PayabliStorageManager.getEntryName()}_pEntry`) && 
            encryptStorage.getItem(`${PayabliStorageManager.getEntryName()}_pEntry`).pEntry ? 
            encryptStorage.getItem(`${PayabliStorageManager.getEntryName()}_pEntry`).pEntry : 0;
        let reactObj = this;

        this.props.reports.getEntrySettings(entry).then(res => {
            if(res.data.customFields){
                let fields = res.data.customFields;
                fields.forEach(function (item, index) {
                    reactObj.props.reports.addHeader(item.key ,{ label:item.key, class: '', display: true, filter: item.key, custom: true});
                });
                this.setState({customFields:fields});
            }
        })
        .catch(error => {
            let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
            toast.error(errorMessage, {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: 'toast-error-container',
            });
        });
    }

    closeVterminalPanel(){
        this.setState({ vterminalRightPanelOpen: false });
    }

    chargeAgain(customer, categories, autopay,record, capture){
        if(capture && capture === true){
            this.setState({actionCapture: true});
            this.props.vTerminal.setOperation("authorize");
        }
        else{
            this.setState({actionCapture: false});
            this.props.vTerminal.setOperation("sale");
        }

        this.props.vTerminal.setPaymentMethod('');
        this.props.vTerminal.setDefaultPaymentMethodActiveKey('2');
        this.props.vTerminal.setPaymentMethodSavedPosition('2');
        this.props.vTerminal.setPaymentMethodSaved(null);
        this.props.vTerminal.setPaymentDataStoredId(record.PaymentData.StoredId);

        let categoriesJS = toJS(categories);
        if (categoriesJS !== null && categoriesJS.length > 0) {
            categoriesJS.forEach(function (item, index) {
                if (typeof item.value === 'undefined' && typeof item.amount !== 'undefined') {
                    item.value = String(item.amount);
                    delete item.amount;
                }
                else {
                    item.value = String(item.value);
                }
                if (typeof item.description === 'undefined') {
                    item.description = item.label;
                }
                if (typeof item.quantity === 'undefined' && typeof item.qty !== 'undefined') {
                    item.quantity = item.qty;
                    delete item.qty;
                }
                if (typeof item.showDescription === 'undefined') {
                    item.showDescription = false;
                }
                if (typeof item.type === 'undefined') {
                    item.type = "quantity";
                }
                if (typeof item.name === 'undefined') {
                    item.name = String(Date.now());
                }
            });
        }
        else {
            categoriesJS = [{
                name: "amountDefaultPayabliApp",
                type: 'customer',
                label: 'Amount you wish to charge',
                value: String(record.NetAmount),
                description: '',
                quantity: 1,
                showDescription: true
            }];
        }
                
        if(customer){
            if (typeof customer.Firstname === 'undefined' && typeof customer.FirstName !== 'undefined') {
                customer.Firstname = customer.FirstName;
            }

            if (typeof customer.Lastname === 'undefined' && typeof customer.LastName !== 'undefined') {
                customer.Lastname = customer.LastName;
            }

            if (typeof customer.Email === 'undefined' && typeof customer.BillingEmail !== 'undefined') {
                customer.Email = customer.BillingEmail;
            }

            this.props.vTerminal.selectCustomerObject(customer);
        }
        this.props.global.setLoading(true);
        this.props.customer.getCustomerFromApi(customer.customerId).then(res => {
            if(res.data){
                let customer = res.data;
                this.props.vTerminal.selectCustomerObject(customer);
                let credentialsPermissions = this.props.vTerminal.getCredentialsPermissions;
                
                if(this.props.vTerminal.getCustomerSelected.StoredMethods && this.props.vTerminal.getCustomerSelected.StoredMethods.length === 0){
                    if(this.props.vTerminal.hasCards && ((credentialsPermissions.card.onetime && !this.props.vTerminal.isAutopay) || (credentialsPermissions.card.recurring && this.props.vTerminal.isAutopay))){
                        this.props.vTerminal.setPaymentMethod('card');
                        this.props.vTerminal.setDefaultPaymentMethodActiveKey("0");
                    }else if(this.props.vTerminal.hasECheck && ((credentialsPermissions.ach.onetime && !this.props.vTerminal.isAutopay) || (credentialsPermissions.ach.recurring && this.props.vTerminal.isAutopay))){
                        this.props.vTerminal.setPaymentMethod('ach');
                        this.props.vTerminal.setDefaultPaymentMethodActiveKey("1");
                    }                    
                }
                
                this.props.vTerminal.setAmountCategories(categoriesJS);
                this.openVterminalPanel(autopay);
            }
            else{
                this.props.global.setLoading(false);
                let errorMessage =  "Something is Wrong!";
                toast.error(errorMessage, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            }
            this.props.global.setLoading(false);
        })
        .catch(error => {
            this.props.global.setLoading(false);
            let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
            toast.error(errorMessage, {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: 'toast-error-container',
            });
        });
    }

    openVterminalPanel(autopay){
        if(autopay === 1){
            this.props.vTerminal.disableAutopay(true);
        }
        else{
            this.props.vTerminal.disableAutopay(false);
        }
        this.props.vTerminal.updateCustomerPaymentsOptions();
        this.setState({ vterminalRightPanelOpen: true, vTerminalAutopay: autopay });
    }

    handleRefundAmount(value){
        this.setState({ refundAmount: value });
        if(value < 0.01){
            this.setState({ refundAmountError: true });
        }
        else{
            if(value > this.state.refundAmountMax){
                this.setState({ refundAmountError: true });
            }else{
                this.setState({ refundAmountError: false });
            }            
        }
    }

    handleCaptureAmount(value) {
        this.setState({ captureAmount: value });
        if (value > this.state.captureAmountMax) {
          this.setState({ captureAmountError: true });
        } else {
          this.setState({ captureAmountError: false });
        }
    }
    
    handleSendReceiptAddress(value){
        this.setState({ sendReceiptAddress: value });
        if(!this.props.global.validators.isEmpty(value) && !this.props.global.validators.stringValidator('email',value)){
            this.setState({ sendReceiptError: false });
        }
        else{
            this.setState({ sendReceiptError: true });
        }
    }

    voidTransaction(transaction){
        this.setState({ transIdToVoid: transaction });
        this.openVoidModal();
    }

    sendTransactionReceipt(transaction, email){
        this.setState({ sendReceiptAddress: email, transIdToSendReceipt: transaction, sendReceiptError: email ? false : true });
        this.openSendReceiptModal();
    }

    refundTransaction(transaction, totalAmount){
        this.setState({ 
            transIdToRefund: transaction, 
            refundAmount: String(totalAmount),
            refundAmountMax: totalAmount,
            refundAmountError: false
        });
        this.openRefundModal();
    }

    captureTransaction(transaction, totalAmount) {
        this.setState({
          transIdToCapture: transaction,
          captureAmount: String(totalAmount),
          captureAmountMax: totalAmount,
          captureAmountError: false,
        });
        this.openCaptureModal();
    }
    
    voidTransactionAction(){
        let transIdToVoid = this.state.transIdToVoid;
        if(transIdToVoid){
            this.props.global.setLoading(true);
            this.props.reports.voidTransaction(transIdToVoid)
            .then(result => {
                this.setState({ voidModalIsOpen: true });
                this.props.global.setLoading(false);
                if (result.data.responseData.resultCode && result.data.responseData.resultCode !== 1) {
                    let message = result.data.responseText ? "Sorry, the operation was " + result.data.responseText : 'Sorry, we have a problem voiding the payment.';
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-error-container',
                    });
                }
                else {
                    let records = this.props.reports.records;
                    records.forEach(function (item, index) {
                        if (item.PaymentTransId === transIdToVoid) {
                            records[index].TransStatus = 5;
                        }
                    });
                    toast.success("Voided successfully!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-success-container'
                    });
                }                
            })
            .catch(error => {
                this.props.global.setLoading(false);
                let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
                toast.error(errorMessage, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            });
        }
    }

    reversalCreditTransaction(){
        let transIdToVoid = this.state.transIdToVoid;
        if(transIdToVoid){
            this.props.global.setLoading(true);
            this.props.reports.reversalCreditTransaction(transIdToVoid)
            .then(result => {
                this.closeReversalCreditModal();
                this.props.global.setLoading(false);
                toast.success("Reversal credit successful!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-success-container'
                });
            })
            .catch(error => {
                this.props.global.setLoading(false);
                let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
                toast.error(errorMessage, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            });
        }
    }
    
    refundTransactionAction(){
        if(this.state.refundAmountError){
            return;
        }

        let transIdToRefund = this.state.transIdToRefund;
        
        if(transIdToRefund){
            this.props.global.setLoading(true);
            this.props.reports.refundTransaction(transIdToRefund, this.state.refundAmount)
            .then(result => {
                this.setState({ refundModalIsOpen: true });
                this.props.global.setLoading(false);
                if (result.data.responseData.resultCode && result.data.responseData.resultCode !== 1) {
                    let message = result.data.responseText ? "Sorry, the payment was " + result.data.responseText : 'Sorry, we have a problem refunding your payment.';
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-error-container',
                    });
                }
                else {
                    toast.success("Refund successful!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-success-container'
                    });
                }
            })
            .catch(error => {
                this.props.global.setLoading(false);
                const explanation = error?.response?.data?.responseData?.explanation;
				const responseText = error?.response?.data?.responseText;
				let errorMessage = explanation || responseText || 'Something is Wrong!'
                toast.error(errorMessage, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            });
        }
    }

    captureTransactionAction() {
        if (this.state.captureAmountError) {
          return;
        }
    
        let transIdToCapture = this.state.transIdToCapture;
    
        if (transIdToCapture) {
          this.props.global.setLoading(true);
          this.props.reports
            .captureTransaction(transIdToCapture, this.state.captureAmount)
            .then((result) => {
              this.setState({ captureModalIsOpen: false });
              this.props.global.setLoading(false);
              if (
                result.data.responseData.resultCode &&
                result.data.responseData.resultCode !== 1
              ) {
                let message = result.data.responseText
                  ? "Sorry, the payment was " + result.data.responseText
                  : "Sorry, we're having a problem capturing your payment.";
                toast.error(message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  className: "toast-error-container",
                });
              } else {
                this.setState({
                  paymentApproved: true,
                  captureReceiptModalIsOpen: true,
                  referenceId: result.data.responseData.referenceId
                    ? result.data.responseData.referenceId
                    : "-",
                  paymentAuthCode: result.data.responseData.authCode
                    ? result.data.responseData.authCode
                    : "-",
                });
              }
            })
            .catch((error) => {
              this.props.global.setLoading(false);
              let errorMessage =
                error.response && error.response.data.responseText
                  ? error.response.data.responseText
                  : "Something is Wrong!";
              toast.error(errorMessage, {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: "toast-error-container",
              });
            });
        }
    }

    sendReceiptTransactionAction(){
        if(this.state.sendReceiptError){
            return;
        }

        let transIdToSendReceipt = this.state.transIdToSendReceipt;
        let sendReceiptAddress = this.state.sendReceiptAddress;
        
        if(transIdToSendReceipt && sendReceiptAddress){
            this.props.global.setLoading(true);
            this.props.reports.sendReceiptTransaction(transIdToSendReceipt, sendReceiptAddress)
            .then(result => {
                this.setState({ sendReceiptModalIsOpen: true });
                this.props.global.setLoading(false);
                toast.success("Transaction Receipt Emailed Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 9000,
                    className: 'toast-success-container data-qaid-transactionEmailedSuccessfullyAlert'
                });
            })
            .catch(error => {
                this.props.global.setLoading(false);
                let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
                toast.error(errorMessage, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    className: 'toast-error-container',
                });
            });
        }
    }

    openRefundModal(){
        this.setState({ refundModalIsOpen: false });
    }
    
    closeRefundModal(){
        this.setState({ refundModalIsOpen: true });
    }

    openCaptureModal() {
        this.setState({ captureModalIsOpen: true });
    }
    
    closeCaptureModal() {
        this.setState({ captureModalIsOpen: false });
    }

    openReversalCreditModal(transId){
        this.setState({ reversalCreditModalIsOpen: true, transIdToVoid: transId });
    }

    closeReversalCreditModal(){
        this.setState({ reversalCreditModalIsOpen: false, transIdToVoid: null });
    }

    openVoidModal(){
        this.setState({ voidModalIsOpen: false });
    }
    
    openSendReceiptModal(){
        this.setState({ sendReceiptModalIsOpen: false });
    }
    
    closeSendReceiptModal(){
        this.setState({ sendReceiptModalIsOpen: true });
    }
    
    closeVoidModal(){
        this.setState({ voidModalIsOpen: true });
    }

    closeCaptureReceiptModal() {
        this.setState({ captureReceiptModalIsOpen: false });
    }
    
    getIconResponse(response){       
        switch(response.toString().toLowerCase()){
            case "1":
                return (<HiCheckCircle type="solid" className="green-text icon-side-text"/>);
            default:
                return (<HiXCircle type="solid" className="red-text icon-side-text"/>);
        }
    }

    getMappingFields(){
        return {
            'date': 'transactiondate',
            'paymentId': 'transid',
            'gatewayTransId': 'gatewaytransid',
            'orderId': 'orderid',
            'cycle': 'scheduleid',
            'OrgId': 'orgid',
            'PaypointId': 'paypointid',
            'PaypointLegalname': 'paypointlegal',
            'ExternalPaypointID': 'externalpaypointid',
            'PaypointDbaname': 'paypointdba',
            'ParentOrgName': 'orgname',
            'brand': 'method',
            'totalAmount': 'totalamount',
            'netAmount': 'netamount',
            'feeAmount': 'feeamount',
            'type': 'operation',
            'source': 'source',
            'status': 'status',
            'settlementStatus': 'settlementstatus',
            'batchNumber': 'batchnumber',
            'customer': 'customer',
            'company': 'company',
            'customerNumber': 'customernumber',
            'invoiceNumber': 'invoicenumber',
            // 'authCode': 'authcode',
            'last4': 'lastfour',
        }
    }
    middlwareFields(field) {
        const apiFields = this.getMappingFields();
        return apiFields[field];
    }
    sortBy(e, record){
        this.setState({ sortBy: this.middlwareFields(record[0]) || '', sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc' }, () => {
            this.getReportFromApi();
        });
    }
    getReportFromApi(){
        let tempFilterValue = {};
        if(this.state.sortBy){
            tempFilterValue['sortBy'] = `${this.state.sortDirection}(${this.state.sortBy})`;
        }
        if(this.state.customerId){
            tempFilterValue['customerId(eq)'] = this.state.customerId;
        }
        if(this.state.paymentTransId){
            tempFilterValue['transId(eq)'] = this.state.paymentTransId;
        }
        if(this.state.idtransRefund){
            tempFilterValue['idTrans(eq)'] = this.state.idtransRefund;
            this.setState({head: "Original Payment ID: "+this.state.idtransRefund});
        }
        this.filter(tempFilterValue);
    }

    clearFilters(){
        this.setState({ head: "" }, () => {
            this.props.reports.clearFilters();
            this.getReportFromApi();
        });
	}

    showHideFilters(){
        this.props.global.setFilterRightPanelOpen(true);
    }

    viewRecordDetails(index, object){
        if(object && (this.props.global.isDrag() || object.target.rel === "noreferrer" || object.target.tagName.toLowerCase() === "svg" || object.target.tagName.toLowerCase() === "a" || object.target.tagName.toLowerCase() === "path")){
            return;
        }
        if(object?.target?.id !== "actionsMenuButton"){
            let thisObj = this;
            if(thisObj.props.global.rightPanelOpen && thisObj.props.reports.recordDetails !== index){
                thisObj.props.global.setRightPanelOpen(false);
                thisObj.props.reports.setRecordDetails(index);
                setTimeout(function(){
                    thisObj.props.global.setRightPanelOpen(true);
                }, 500)                
            }else{
                thisObj.props.reports.setRecordDetails(index);
                thisObj.props.global.setRightPanelOpen(true);
            }
        }
    }

    handleShowColumn(event){
        this.props.reports.handleShowColumn(event);
        if (!this.state.flagItemAllColumn) {
            this.setState({flagItemAllColumn: true});
        }
    }

	exportFile(format){
        this.props.reports.exportFile('transactions',format);
    }

    handleQuickFilter(value){
        this.filter('operation(eq)',value)
        this.setState({ head: value });
    }

    filter(type, value){
        this.props.global.setLoading(true);
        this.props.reports.filter(type,value, 'transactions').then(res => {
            this.props.global.setLoading(false);
        })
        .catch(error => {
            this.props.global.setLoading(false);
            let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
            toast.error(errorMessage, {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: 'toast-error-container',
            });
        });
    }

    renderCardPaymentInformation(recordDetail){
        if (recordDetail && recordDetail.Method && recordDetail.Method.toLowerCase() === "card") {
            return (<>
                <div className="row mb-2">
                    <div className="col-7">
                            <label className="grey">Card Number</label>
                        <h5 style={{fontWeight: 500}}>
                        •••• •••• {recordDetail.PaymentData && recordDetail.PaymentData.MaskedAccount ? this.props.global.maskedCardNumber(recordDetail.PaymentData.MaskedAccount, 'v5') : '-'}
                        </h5>
                    </div>                        
                    <div className="col-5 text-center">
                        <label className="grey">Expires on</label>
                        <h5 style={{fontWeight: 500}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.AccountExp ? this.props.global.expDateFormat(recordDetail.PaymentData.AccountExp) : '-'}
                        </h5>
                    </div>                    
                </div>
                <div className="row">
                    <div className="col-12">
                        <label className="grey">Cardholder Name</label>
                        <h6 style={{fontWeight: 500}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.HolderName ? recordDetail.PaymentData.HolderName : '-'}
                        </h6>
                    </div>
                </div>
            </>);
        } else if (recordDetail && recordDetail.Method && recordDetail.Method.toLowerCase() === "ach") {
            return (<>
                <div className="row mb-2">
                    <div className="col-7">
                            <label className="grey">Account Number</label>
                        <h5 style={{fontWeight: 500}}>
                        •••• •••• {recordDetail.PaymentData && recordDetail.PaymentData.MaskedAccount ? this.props.global.maskedCardNumber(recordDetail.PaymentData.MaskedAccount, 'v5') : '-'}
                        </h5>
                    </div>                        
                    <div className="col-5 text-center">
                        <label className="grey">Account Type</label>
                        <h5 style={{fontWeight: 500}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.AccountType ? recordDetail.PaymentData.AccountType  : '-'}
                        </h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <label className="grey">Account Holder Name</label>
                        <h6 style={{fontWeight: 500}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.HolderName ? recordDetail.PaymentData.HolderName : '-'}
                        </h6>
                    </div>
                </div>
            </>);
        } else if (recordDetail && recordDetail.Method && recordDetail.Method.toLowerCase() === "check") {
            return (<>
                <div className="row mb-2">
                    <div className="col-7">
                    <label className="grey">Account Holder Name</label>
                        <h6 style={{fontWeight: 500, fontSize: '1rem'}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.HolderName ? recordDetail.PaymentData.HolderName : '-'}
                        </h6>                            
                    </div>                        
                    <div className="col-5 text-center">
                        <label className="grey">Payment Method</label>
                        <h5 style={{fontWeight: 500, fontSize: '1rem'}}>Physical Check</h5>
                    </div>                    
                </div>
                <div className="row">
                    <div className="col-12">
                    <label className="grey">Check #</label>
                        <h5 style={{fontWeight: 500, fontSize: '1rem'}}>
                            {recordDetail.PaymentData && recordDetail.PaymentData.paymentDetails && recordDetail.PaymentData.paymentDetails.checkNumber ? recordDetail.PaymentData.paymentDetails.checkNumber : '-'}
                        </h5>
                    </div>
                </div>                
            </>);
        } else if (recordDetail && recordDetail.Method && recordDetail.Method.toLowerCase() === "cash") {
            return (<>
                <div className="row mb-2">
                    <div className="col-7">
                        <label className="grey">Payor Name</label>
                        <h5 style={{fontWeight: 500, fontSize: '1rem'}}>
                            {recordDetail.Customer ? (recordDetail.Customer.FirstName ? recordDetail.Customer.FirstName : "") + ' ' + (recordDetail.Customer.LastName ? recordDetail.Customer.LastName : "") : '-'}
                        </h5>
                    </div>
                    <div className="col-5">
                    <label className="grey">Payment Method</label>
                        <h5 style={{fontWeight: 500, fontSize: '1rem'}}>Cash</h5>
                    </div>    
                </div>
            </>);
        }
    }

    renderLast4Report(record){
        if (record) {
            if (record.PaymentData.MaskedAccount && record.PaymentData.MaskedAccount.toLowerCase() === "poi") {
                return (" - ");
            } else if (record.Method && record.Method.toLowerCase() === "check") {
                return (record.PaymentData.paymentDetails.checkNumber && this.props.global.maskedCardNumber(record.PaymentData.paymentDetails.checkNumber, "v7"));
            }else if (record.Method && record.Method.toLowerCase() === "cash") {
                return (" - ");
            }else{
                return (this.props.global.maskedCardNumber(record.PaymentData.MaskedAccount, "v5"));
            }            
        }
        return (" - ");
    }

    renderModalRisks(){
        if (this.state.actionsRisks) {
            const {action, payabliTransId} = this.state.actionsRisks
            return (
                <Modal style={{ textAlign: 'center' }} show={this.state.modalConfirmationRisks} onHide={()=> this.deleteModalStatus(false)} size="sm" aria-labelledby="contained-modal-title-vcenter" centered >
                    <Modal.Body>
                        <AiOutlineAlert className="icon-modal" />
                        <h5>{action === 'hold' ? 'Hold' : 'Release'}</h5>
                        <p className="small mb-4">This action will <strong>{action === 'hold' ? 'Hold' : 'Release'}</strong> the Transaction selected, do you want to continue?</p>
                        <Button className="btn cancel-btn" variant="default" onClick={()=> this.showModalConfirmationRisks()}>Cancel</Button>
                        &nbsp;&nbsp;
                        <Button className="btn" variant="primary" onClick={()=> this.savedActionsRisks(action, payabliTransId)}>Save</Button>
                    </Modal.Body>
                </Modal>
            )
        }
        return null
    }
    
    showModalConfirmationRisks(action, payabliTransId){
        let modalConfirmationRisks = !this.state.modalConfirmationRisks
        let actionsRisks = {
            'action': action,
            'payabliTransId': payabliTransId
        }
        this.setState({modalConfirmationRisks: modalConfirmationRisks, actionsRisks: actionsRisks})
    }

    savedActionsRisks(action, payabliTransId){
        if (action && payabliTransId) {
            this.props.global.setLoading(true);
            if (action === 'hold') {
                this.props.management.actionHoldTransaction(payabliTransId)
                .then(result => {
                    this.props.global.setLoading(false);
                    toast.success("Transaction has been successfully held!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-success-container'
                    });
                    this.getReportFromApi();
                })
                .catch(error => {
                    this.props.global.setLoading(false);
                    let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
                    toast.error(errorMessage, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-error-container',
                    });
                });
            }
            if (action === 'release') {
                this.props.management.actionReleaseTransaction(payabliTransId)
                .then(result => {
                    this.props.global.setLoading(false);
                    toast.success("Transaction has been successfully released!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-success-container'
                    });
                    this.getReportFromApi();
                })
                .catch(error => {
                    this.props.global.setLoading(false);
                    let errorMessage = error.response && error.response.data.responseText ? error.response.data.responseText : "Something is Wrong!";
                    toast.error(errorMessage, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        className: 'toast-error-container',
                    });
                });
            }
            this.showModalConfirmationRisks()
            this.props.global.setLoading(false);
        }
        return
    }

    renderActionHoldReleasedTrx(record) {
        const { TransStatus, SettlementStatus, PaymentTransId, ConnectorName } = record;
        if (TransStatus === 1 && ConnectorName?.toLowerCase() === 'gp') {
            return <>
                <Dropdown.Divider />
                <span className='small' style={{ fontSize: '10px', marginLeft: '15px' }}>RISK</span>
                {(SettlementStatus === 0 || SettlementStatus === 1) && <Dropdown.Item onClick={() => this.showModalConfirmationRisks('hold', PaymentTransId)}>Hold Transaction</Dropdown.Item>}
                {(SettlementStatus === -5) && <Dropdown.Item onClick={() => this.showModalConfirmationRisks('release', PaymentTransId)}>Release Transaction</Dropdown.Item>}
            </>;
        }
    }

    allowCaptureTransaction(record) {
        const { TransStatus, TransactionTime } = record;        
        const currentDate = new Date();
        const expirationDate = new Date(TransactionTime);
        expirationDate.setDate(expirationDate.getDate() + 10);
        return (TransStatus === 11 && currentDate <= expirationDate);
    }

    render() {
        const { totalAmount = 0, totalRecords = 0 } = this.props?.reports || {};
        const rangeDate = this.props.filter?.stateDate?.endDateDate
			? ` ${
					this.props.filter.stateDate.startDateDate
						? this.props.reports.dateStringFormat(this.props.filter.stateDate.startDateDate)
						: ''
			  } → ${
					this.props.filter.stateDate.endDateDate
						? this.props.reports.dateStringFormat(this.props.filter.stateDate.endDateDate)
						: ''
			  }`
			: 'Last 60 days';
        
        return (
            <Layout {...this.props}>

                <div id="vterminal-rigth-panel" className={ this.state.vterminalRightPanelOpen ? 'open' : ''}>
                    <div className="popover-body popover-body-2">
                        <BiX id="right-panel-close" onClick={(e) => this.closeVterminalPanel()}/>
                        <h5 className="header mb-3" data-qaid="transactionMoneyInChargeAgainView">{this.state.actionCapture === true ? "Capture": "Charge Again"}</h5>
                        <VirtualTerminal isEmbedded={true} paymentSuccessFunctionCallBack={this.closeVterminalPanel} autopay={0}/>
                    </div>
                </div>
                {this.state.vterminalRightPanelOpen  &&
                <div onClick={(e) => this.closeVterminalPanel()} id="right-panel-layer"></div>
                }

            <div>
                {this.state.userPermissions.indexOf("Void") !== -1  &&
                <Modal style={{textAlign: "center"}} show={!this.state.voidModalIsOpen} onHide={this.closeVoidModal}  size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <BiXCircle className="icon-modal"/>
                    <h5 data-qaid="transactionMoneyInVoidPopUp">Void</h5>
                    <p className="small">Are you sure you want to void this transaction?</p>
                    <Button className="btn cancel-btn" variant="default" onClick={(e) => this.closeVoidModal()} data-qaid="cancelTransactionMoneyInButton">
                        Cancel
                    </Button>
                    &nbsp;&nbsp;
                    <Button className="btn" variant="primary" onClick={this.voidTransactionAction} data-qaid="voidTransactionMoneyInButton">
                        Void
                    </Button>
                </Modal.Body>
                </Modal>
                }
                <Modal style={{textAlign: "center"}} show={this.state.reversalCreditModalIsOpen} onHide={this.closeReversalCreditModal}  size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                    <Modal.Body>
                        <BiXCircle className="icon-modal"/>
                        <h5>Reversal Credit</h5>
                        <p className="small">Are you sure you want to Reversal Credit this transaction?</p>
                        <Button className="btn cancel-btn" variant="default" onClick={() => this.closeReversalCreditModal()}>
                            Cancel
                        </Button>
                        &nbsp;&nbsp;
                        <Button className="btn" variant="primary" onClick={this.reversalCreditTransaction}>
                            Reversal Credit
                        </Button>
                    </Modal.Body>
                </Modal>

                    {this.state.userPermissions.indexOf("Refund") !== -1  &&
                <Modal style={{textAlign: "center"}} show={!this.state.refundModalIsOpen} onHide={this.closeRefundModal}  size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <BiShare className="icon-modal"/>
                    <h5>Refund Payment</h5>
                    <p className="small">Transaction Id:</p>
                    <p className="small-grey">{this.state.transIdToRefund}</p>

                    <NumberFormat
                        onFocus={(e)=>this.focus(e)} 
                        thousandsGroupStyle="thousand"
                        decimalSeparator="."
                        displayType="input"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={false}
                        decimalScale={2}
                        fixedDecimalScale={true}

                        value={this.state.refundAmount}
                        placeholder= {"Max amount $" + this.props.global.numberWithCommas(this.state.refundAmountMax.toFixed(2))}
                        className={this.state.refundAmountError ? "form-control input-money-v2 mb-3 input-error" : "form-control input-money-v2 mb-3" }
                        onValueChange={(values) => this.handleRefundAmount(values.value)}
                    />

                    <Button className="btn full-w" variant="primary" onClick={this.refundTransactionAction}>
                        Refund
                    </Button>
                </Modal.Body>
                </Modal>
                }

                {this.state.userPermissions.indexOf("Accept Payments") !== -1 && (
                            <Modal
                            style={{ textAlign: "center" }}
                            show={this.state.captureModalIsOpen}
                            onHide={this.closeCaptureModal}
                            size="sm"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            >
                            <Modal.Body>
                                <BiDollarCircle className="icon-modal" />
                                <h5>Capture Payment</h5>
                                <p className="small">Transaction Id:</p>
                                <p className="small-grey">{this.state.transIdToCapture}</p>

                                <NumberFormat
                                onFocus={(e) => this.focus(e)}
                                thousandsGroupStyle="thousand"
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={false}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                value={this.state.captureAmount}
                                placeholder={
                                    "Max amount $" +
                                    this.props.global.numberWithCommas(
                                    this.state.captureAmountMax.toFixed(2)
                                    )
                                }
                                className={
                                    this.state.captureAmountError
                                    ? "form-control input-money-v2 mb-3 input-error"
                                    : "form-control input-money-v2 mb-3"
                                }
                                onValueChange={(values) =>
                                    this.handleCaptureAmount(values.value)
                                }
                                />

                                <Button
                                className="btn full-w"
                                variant="primary"
                                onClick={this.captureTransactionAction}
                                >
                                Capture
                                </Button>
                            </Modal.Body>
                            </Modal>
                        )}

                        <Modal
                            show={this.state.captureReceiptModalIsOpen}
                            onHide={this.closeCaptureReceiptModal}
                            size="md"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Body>
                            <div className="text-center mt-4">
                                <b>Capture Receipt</b>
                                <h2 className="mb-4 mt-4">
                                $
                                {this.props.global.numberWithCommas(
                                    parseFloat(this.state.captureAmount).toFixed(2)
                                )}
                                </h2>
                                {this.state.paymentApproved ? (
                                <p>
                                    <BiCheckCircle
                                    style={{ fontSize: "28px", color: "rgb(136,201,82)" }}
                                    />{" "}
                                    Approved
                                </p>
                                ) : (
                                <>
                                    <p className="mb-2">
                                    <BiCheckCircle
                                        style={{
                                        fontSize: "28px",
                                        color: "rgb(255, 100, 82)",
                                        }}
                                    />{" "}
                                    Declined
                                    </p>
                                    <p className="small-grey mt-0 mb-2">
                                    {this.state.paymentResponseMessage}
                                    </p>
                                </>
                                )}
                            </div>

                            <div
                                className="review-total mb-3"
                                style={{ borderBottom: "none" }}
                            >
                                <div className="row mb-3 mt-3">
                                <div className="col-6 text-left">
                                    <small>
                                    Paid on{" "}
                                    {this.props.global.stringDateFormat(
                                        new Date().toString()
                                    )}
                                    ,{" "}
                                    {this.props.global.stringTimeFormat(
                                        new Date().toString()
                                    )}
                                    </small>
                                </div>
                                </div>

                                <div className="row">
                                <div className="col">Payment:</div>
                                <div className="col">
                                    $
                                    {this.props.global.numberWithCommas(
                                    parseFloat(this.state.captureAmount).toFixed(2)
                                    )}
                                </div>
                                </div>

                                <div className="top-border-grey mt-2 bottom-border-grey">
                                <div className="row total-amount">
                                    <div className="col">Total Amount:</div>
                                    <div className="col">
                                    $
                                    {this.props.global.numberWithCommas(
                                        parseFloat(this.state.captureAmount).toFixed(2)
                                    )}
                                    </div>
                                </div>
                                </div>

                                <div className="mt-2">
                                <div className="row total-amount">
                                    <div className="col-4">Reference Id: </div>
                                    <div className="col-8">
                                    {this.state.referenceId ? this.state.referenceId : ""}
                                    </div>
                                    {this.state.paymentApproved && (
                                    <>
                                        <div className="col-4">AuthCode: </div>
                                        <div className="col-8">
                                        {this.state.paymentAuthCode
                                            ? this.state.paymentAuthCode
                                            : ""}
                                        </div>
                                    </>
                                    )}
                                </div>
                                </div>
                            </div>

                            <Button
                                id="btnCloseReceipt"
                                className="btn full-w btn-lg"
                                onClick={this.closeCaptureReceiptModal}
                            >
                                Close
                            </Button>
                            </Modal.Body>
                        </Modal>

                <Modal style={{textAlign: "center"}} show={!this.state.sendReceiptModalIsOpen} onHide={this.closeSendReceiptModal}  size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <BiMailSend className="icon-modal"/>
                    <h5 data-qaid="transactionMoneyInSendReceiptPopUp">Send Receipt</h5>
                    <p className="small">Transaction Id:</p>
                    <p className="small-grey">{this.state.transIdToSendReceipt}</p>

                    <IMaskInput
                        mask={this.props.global.maskValidator('email')}
                        value={this.state.sendReceiptAddress}
                        unmask={true}
                        placeholder= "Email"
                        className={this.state.sendReceiptError ? "form-control mb-3 input-error" : "form-control mb-3" }
                        onAccept={
                            (value, mask) => this.handleSendReceiptAddress(value)
                        }
                    />
                    <div className="row">
                        <div className="col">
                            <Button className="btn cancel-btn full-w" variant="default" onClick={(e) => this.closeSendReceiptModal()}>
                                Cancel
                            </Button>
                        </div>
                        <div className="col">
                            <Button className="btn full-w" variant="primary" onClick={this.sendReceiptTransactionAction} data-qaid="sendTransactionMoneyInButton">
                                Send
                            </Button>
                        </div>
                    </div>
                   
                </Modal.Body>
                </Modal>

                <RightPanel>
                    <h5 className="header mb-3" data-qaid="transactionMoneyInViewDetails">Transaction Details</h5>
                    <QuickViewTransaction ref={this.quickViewTransaction} />
                </RightPanel>
                <ParentFilterPanel report={'transactions'} customFields={this.state.customFields} customerId={this.props.match.params.id} paypointId={this.props.match.params.idPaypoint} transId={this.props.match.params.paymentTransId} />
                <TopBar>
                <MainTopBarMenu/>
                <div className="top-bar-sub">
                { (this.props.match.params.gobackData && this.state.gobackData) ?
                    <>
                        <CustomerLinks gobackLink={this.state.gobackData ? this.state.gobackData.url : ""} gobackText={this.state.gobackData ? this.state.gobackData.label : ""} history={this.props.history} goback={true} selected="payhistory" id={this.state.customerId} />
                    </>
                    :
                    <>
                    {
                    this.state.customerId ?
                        <CustomerLinks gobackLink={"/"+PayabliStorageManager.getEntryName()+'/customer/'+this.state.customerId} gobackText="Customer Overview" history={this.props.history} goback={true} selected="payhistory" id={this.state.customerId} />
                        :
                        <ReportsLinks selected="transactions" id={this.state.customerId} history={this.props.history} goback={this.state.customerId ? true : false} />
                    }
                    </>
                }
                </div>
                </TopBar>
                <div className="mt-body4">
                    <MainBar
                        reportNameComponent={this.getNameComponent}
                        dataQAName="TransactionsMoneyIn"
                        showHideFilters={this.showHideFilters}
                        selectAllColumns={(e) => this.selectAllColumns(e, "columnReport")}
                        handleShowColumn={(e) => this.handleShowColumn(e)}
                        getHeaders={this.props.reports.getHeaders}
                        headers={this.props.reports.headers}
                        refreshView={this.clearFilters}
                        buttonExport={true}
                        searchBar={false}
                        exportFile={this.exportFile}
                        withTotal={true}
                        reportTransaction={true}
                        totalRecords={totalRecords || 0}
                        totalAmount={totalAmount ? this.props.global.numberWithCommas(totalAmount.toFixed(2)) : '$ 0.00'}
                        rangeDate={rangeDate}
                        flagItemAllColumn={this.state.flagItemAllColumn}
                        balanceLine={true}
                    /> 
                <div className="report-container">  
                <table className="table table-hover table-striped">
                    <thead>
                    <tr>
                        {
                            this.props.reports.getHeaders.map((record, i) => (
                                (Object.entries(this.getMappingFields()).flat(1).includes(record[0]) &&
                                record[1].display && 
                                (<th key={i} scope="col" className={`${record[1].class} sortby-parent`}>{record[1].label}
                                <BiSortAlt2 className='cursorPointer sort-icon' onClick={(e) => this.sortBy(e, record)}/>
                            </th> ))
                                ||
                                (record[1].display && 
                                (<th key={i} scope="col" className={record[1].class}>{record[1].label}
                                </th> ))
                            ))
                        }
                        <th className='text-center sticky-row' scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>                
                { this.props.reports.records.map((record, i) => (
                       <tr key={i} className="cursorPointer" onClick={(e) => this.viewRecordDetails(i,e)} onMouseUp={(e)=>this.props.global.setCoordClickUp(e)} onMouseDown={(e)=>this.props.global.setCoordClickDown(e)} data-qaid={"transactionMoneyInRow-"+(i)}>
                            { (this.props.reports.headers.paymentId && this.props.reports.headers.paymentId.display) &&
                                <td>
                                {record.PaymentTransId ? record.PaymentTransId.substring(0, 20) : ''}...
                                </td>
                            }
                            { (this.props.reports.headers.gatewayTransId && this.props.reports.headers.gatewayTransId.display) &&
                                <td>{record && record.GatewayTransId ? record.GatewayTransId: '-'}</td>
                            }
                            { (this.props.reports.headers.orderId && this.props.reports.headers.orderId.display) &&
                               <td>{record && record.OrderId ? record.OrderId: '-'}</td>
                            }
                            { (this.props.reports.headers.batchNumber && this.props.reports.headers.batchNumber.display) &&
                                <td>{record.BatchNumber ? record.BatchNumber : '-'}</td>
                            }
                            { (this.props.reports.headers.ExternalPaypointID && this.props.reports.headers.ExternalPaypointID.display) &&
                                <td>{record && record.externalPaypointID ? record.externalPaypointID : '-'}</td>
                            }
                            { (this.props.reports.headers.customer && this.props.reports.headers.customer.display) &&
                                <td>
                                    <div className='d-flex align-items-center flex-nowrap gap-1'>
                                        <span>{record.Customer && record.Customer.FirstName ? this.props.global.capitalizeFirstLetterOfEachWord(record.Customer.FirstName) : '-'} { record.Customer && record.Customer.LastName ? this.props.global.capitalizeFirstLetterOfEachWord(record.Customer.LastName) : ''}</span>
                                    </div>
                                </td>
                            }
                            { (this.props.reports.headers.company && this.props.reports.headers.company.display) &&
                                <td>{record.Customer && record.Customer.CompanyName ? this.props.global.capitalizeFirstLetterOfEachWord(record.Customer.CompanyName) : '-'}</td>
                            }
                            { (this.props.reports.headers.customerNumber && this.props.reports.headers.customerNumber.display) &&
                                <td>{record.Customer && record.Customer.CustomerNumber ? record.Customer.CustomerNumber.length > 15 ? record.Customer.CustomerNumber.substring(0, 15) + "..." : record.Customer.CustomerNumber : '-'} </td>
                            }                            
                            { (this.props.reports.headers.billingEmail && this.props.reports.headers.billingEmail.display) &&
                                <td>{record.Customer && record.Customer.BillingEmail ? record.Customer.BillingEmail : '-'} </td>
                            }                            
                            { (this.props.reports.headers.payorPhone && this.props.reports.headers.payorPhone.display) &&
                                <td>{record.Customer && record.Customer.BillingPhone ? this.props.global.phoneNumberFormat(record.Customer.BillingPhone): '-'} </td>
                            }                           
                            { (this.props.reports.headers.billingAddress && this.props.reports.headers.billingAddress.display) &&
                                <td>{record.Customer && record.Customer.BillingAddress1 ? (record.Customer.BillingAddress1 ? record.Customer.BillingAddress1: " "+ record.Customer.BillingAddress2 ? record.Customer.BillingAddress2: " "+ record.Customer.BillingCity ? record.Customer.BillingCity: " "+ record.Customer.BillingState ? record.Customer.BillingState: " "+ record.Customer.BillingZip ? record.Customer.BillingZip: " "+ record.Customer.BillingCountry ? record.Customer.BillingCountry: "") : '-'} </td>
                            }                            
                            { (this.props.reports.headers.shippingAddress && this.props.reports.headers.shippingAddress.display) &&
                                <td>{record.Customer && record.Customer.ShippingAddress1 ? (record.Customer.ShippingAddress1 ? record.Customer.ShippingAddress1: " "+ record.Customer.ShippingAddress2 ? record.Customer.ShippingAddress2: " "+ record.Customer.ShippingCity ? record.Customer.ShippingCity: " "+ record.Customer.ShippingState ? record.Customer.ShippingState: " "+ record.Customer.ShippingZip?record.Customer.ShippingZip: " "+ record.Customer.ShippingCountry ? record.Customer.ShippingCountry: ""): '-'} </td>
                            }
                            { (this.props.reports.headers.invoiceNumber && this.props.reports.headers.invoiceNumber.display) &&
                                <td>{record.invoiceData && record.invoiceData.invoiceNumber ? record.invoiceData.invoiceNumber: '-'}</td>
                            }                            
                            { (this.props.reports.headers.date && this.props.reports.headers.date.display) &&
                                <td>{this.props.global.stringDateFormatV3(record.TransactionTime)}</td>
                            }
                            { (this.props.reports.headers.time && this.props.reports.headers.time.display) && 
                                <td>{this.props.global.stringTimeFormat(record.TransactionTime)}</td>
                            }
                            { (this.props.reports.headers.brand && this.props.reports.headers.brand.display) && 
                                <td className='text-center'>{this.props.global.getPaymethodImgPaymentData(record)}</td>
                            }
                            { (this.props.reports.headers.last4 && this.props.reports.headers.last4.display) && 
                                <td>{ this.renderLast4Report(record) }</td>
                            }
                            { (this.props.reports.headers.type && this.props.reports.headers.type.display) && 
                                <td>{record.Operation}</td>
                            }
                            { (this.props.reports.headers.cycle && this.props.reports.headers.cycle.display) && 
                                <td>{record.ScheduleReference > 0 ? 'Scheduled' : 'One-Time'}</td>
                            }
                            { (this.props.reports.headers.status && this.props.reports.headers.status.display) && 
                                <td>{this.props.global.getTransStatus(record.TransStatus)}</td>
                            }
                            { (this.props.reports.headers.settlementStatus && this.props.reports.headers.settlementStatus.display) && 
                                <td>
                                    {
                                        this.props.global.getSettlementTransStatus(record.SettlementStatus, record)                                        
                                    }                                    
                                    {
                                        Array.isArray(record.splitFundingInstructions) && 
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Split Funded</Tooltip>}>
                                            <MdOutlineCallSplit style={{color:'#7B61FF', transform: 'rotate(90deg)', width:'16px', height:'16px'}}/>
                                        </OverlayTrigger>
                                    }                                    
                                </td>
                            }
                            { (this.props.reports.headers.netAmount && this.props.reports.headers.netAmount.display) && 
                                <td className='text-right'>{this.props.global.numberWithCommasNegative(record.NetAmount.toFixed(2))}</td>
                            }
                            { (this.props.reports.headers.feeAmount && this.props.reports.headers.feeAmount.display) && 
                                <td className='text-right'>${this.props.global.numberWithCommas(record.FeeAmount.toFixed(2))}</td>
                            }                          
                            { (this.props.reports.headers.totalAmount && this.props.reports.headers.totalAmount.display) && 
                                <td className='text-right'>{this.props.global.numberWithCommasNegative(record.TotalAmount.toFixed(2))}</td>
                            }
                            { (this.props.reports.headers.currency && this.props.reports.headers.currency.display) && 
                                <td className='text-center'>{record.PaymentData ? record.PaymentData.paymentDetails.currency ? record.PaymentData.paymentDetails.currency : '-' : '-'}</td>
                            }                            
                            { (this.props.reports.headers.authCode && this.props.reports.headers.authCode.display) && 
                                <td>{record.ResponseData.authcode ? record.ResponseData.authcode : '-'}</td>
                            }                            
                            { (this.props.reports.headers.source && this.props.reports.headers.source.display) && 
                                <td>
                                    {record.Source 
                                        ? ['ivr', 'api'].includes(record.Source.toLowerCase())
                                            ? record.Source.toUpperCase() 
                                            : this.props.global.capitalizeFirstLetter(record.Source)
                                        : '-'}
                                </td>
                            }
                            { (this.props.reports.headers.notes && this.props.reports.headers.notes.display) && 
                                <td className='text-center'>
                                    {record.PaymentData && record.PaymentData.orderDescription ? 
                                        <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>{record.PaymentData.orderDescription}</Tooltip>}
                                        >
                                        <BiNotepad className="label-info-icon in-input"/>
                                        </OverlayTrigger>
                                    : '-'}
                                </td>
                            }
                            {
                                 this.state.customFields.map((field, i) => (
                                    (this.props.reports.headers[field.key] && this.props.reports.headers[field.key].display) && 
                                     <td key={i}>{record.Customer && record.Customer.AdditionalData && record.Customer.AdditionalData[field.key] ? record.Customer.AdditionalData[field.key] : '-'}</td>
                                 ))
                            }
                            <td className='text-center sticky-row'>
                                <DropdownButton
                                    menuAlign="right"
                                    title={<BiDotsVerticalRounded/>}
                                    data-qaid={"actionTransactionMoneyIn-"+(record.PaypointLegalname)}
                                    id="actionsMenuButton"
                                    size="sm"
                                    variant="default"
                                >
                                <Dropdown.Item onClick={(e) => this.viewRecordDetails(i)} data-qaid="transactionMoneyInQuickViewLink"><div>Quick View</div></Dropdown.Item>
                                <Dropdown.Item onClick={() => this.quickViewTransaction.current.sendTransactionReceipt(record.PaymentTransId, record.Customer?record.Customer.BillingEmail:'') } data-qaid="transactionMoneyInSendReceiptLink">Send Receipt</Dropdown.Item>
                                {(this.state.userPermissions.indexOf("Customers") >0 && record.PayorId>0)  &&
                                <Dropdown.Item as={Link} to={ record.Customer ? ("/" + this.props.global.getURLEntry() + "/customer/" + record.Customer.customerId) : ''} data-qaid="transactionMoneyInViewCustomerLink">View Customer</Dropdown.Item>
                                }
                                {(this.state.userPermissions.indexOf("Accept Payments") >0 && record.PayorId > 0)  &&
                                <Dropdown.Item onClick={(e) => this.chargeAgain(record.Customer ,record.PaymentData.paymentDetails.categories, 0,record)} data-qaid="transactionMoneyInChargeAgainLink">Charge Again</Dropdown.Item>
                                }
                                {(this.state.userPermissions.indexOf("Accept Payments") !== -1 && this.allowCaptureTransaction(record)) &&
                                <Dropdown.Item onClick={(e) => this.captureTransaction(record.PaymentTransId,record.NetAmount)} data-qaid="transactionMoneyInCaptureLink">Capture</Dropdown.Item>
                                }
                                {this.state.userPermissions.indexOf("Refund") !== -1  &&
                                 <>
                                {(record && record.SettlementStatus >= 1) &&
                                <Dropdown.Item onClick={() => this.quickViewTransaction.current.refundTransaction(record.PaymentTransId, record.NetAmount) } data-qaid="transactionMoneyInRefundLink">Refund</Dropdown.Item>
                                }
                                </>
                                }
                                {this.state.userPermissions.indexOf("Void") !== -1  &&
                                 <>
                                {(record && (record.SettlementStatus === 0 && (record.TransStatus === 1 || record.TransStatus === 11) )) &&
                                <Dropdown.Item onClick={() => this.quickViewTransaction.current.voidTransaction(record.PaymentTransId) } data-qaid="transactionMoneyInVoidLink">Void</Dropdown.Item>
                                }
                                </>
                                }
                                {record.Operation?.toLowerCase() === 'credit' && (record.TransStatus === 1 || record.TransStatus === 11) &&
                                <Dropdown.Item onClick={() => this.openReversalCreditModal(record.PaymentTransId) } data-qaid="transactionMoneyInCreditLink">Reversal Credit</Dropdown.Item>
                                }
                                { this.state.userPermissions.includes("Management") && this.renderActionHoldReleasedTrx(record) }
                                </DropdownButton>                              
                            </td>
                        </tr>
                    ))
                }                
                </tbody>
                </table>                
                {( this.props.reports.records.length < 1 ) &&
                    <RecordsNotFound btnLink={`/${PayabliStorageManager.getEntryName()}/vterminal`} btnText="+ Accept payment" message="No transactions in this period" description={<span>There aren't any transactions for this period. Try filtering by a different period.<br />When your customers make payments, you can track transaction details here in real time.</span>}/>
                }                
                </div>
                <ReportPaginator report="transactions"/>
                </div>
                <ToastContainer transition={Bounce} />
            </div>
            {this.renderModalRisks()}
            </Layout>
        )
       
    }
}

export { TransactionsReport };
